<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Paging Group</h1>
        <div class="modal-actions col-2">
          <el-button
            type="primary"
            @click="createOperation"
            :disabled="numUsed"
          >
            Create
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
          >
            Cancel
          </el-button>
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          />
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group">
        <el-col :span="11">
          <el-input v-model="number" placeholder="Enter number">
            <template slot="prefix"><span>Number</span></template>
            <template slot="append" v-if="numUsed">
              <in-use :inUse="numInUse"
            /></template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="12">
          <el-input v-model="createForm.name" placeholder="Enter name">
            <template slot="prefix"><span>Name</span></template>
          </el-input>
        </el-col>
      </div>

      <div class="inline-form-group">
        <el-checkbox v-model="createForm.twoWayAudio"
          >Enable two way audio</el-checkbox
        >
      </div>

      <div class="inline-form-group">
        <el-checkbox v-model="createForm.checkInUse"
          >Enable checking if extension is in use</el-checkbox
        >
      </div>

      <h2 class="form-section-header">
        Assign extensions
      </h2>
      <el-select
        v-model="createForm.extensions"
        placeholder="Select extensions"
        remote
        :remote-method="remoteMethodForExts"
        filterable
        multiple
      >
        <template slot="prefix">
          <span style="opacity: 0;">Extensions</span>
        </template>
        <el-option
          v-for="(ext, idx) in extOptions"
          :key="idx + getRandomKey()"
          :label="`${ext.name}${ext.number ? '-' + ext.number : ''}`"
          :value="ext.id"
        />
      </el-select>

      <!-- ⭐ Play Intro Message -->
      <div class="inline-form-group">
        <el-col :span="24">
          <existing-mediafile
            title="Play intro message"
            :multiple="false"
            :clearState="clearFormFields"
            :newMediafile="newMediafile"
            @mediafileSelected="onPlayIntroMsgSelected"
          />
          <new-mediafile @mediafileSaved="onNewMediafileCreation" />
        </el-col>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import ExistingMediafile from "@/components/ExistingMediafile";
import NewMediafile from "@/components/NewMediafile";
import InUse from "@/components/InUse";

export default {
  name: "PagingGroupCreateForm",

  props: {
    reRenderKey: { required: true },
    createVisible: { required: true },
    createProcessing: { required: true },
    extOptions: { required: true },
    numInUse: { required: true },
    clearFormFields: { required: true }
  },

  components: {
    ExistingMediafile,
    NewMediafile,
    InUse
  },

  data() {
    return {
      newMediafile: null,
      number: "",
      createForm: {
        tenantId: null,
        number: "",
        name: "",
        twoWayAudio: false,
        checkInUse: false,
        extensions: [],
        meId: 0
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    numUsed() {
      return this.numInUse && this.numInUse.inUse;
    }
  },

  watch: {
    number(val) {
      if (val) {
        this.createForm.number = val;
        this.$emit("checkForAvailableNum", val);
      }
    },

    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    }
  },

  methods: {
    onNewMediafileCreation(newMediafile) {
      this.newMediafile = newMediafile;
    },

    onPlayIntroMsgSelected(meId) {
      this.createForm.meId = meId;
    },

    onMediafileSaved(id) {
      this.createForm.meId = id;
    },

    remoteMethodForExts(query) {
      this.$emit("remoteMethodForExts", query);
    },

    createOperation() {
      const createBody = { ...this.createForm };
      createBody.twoWayAudio = createBody.twoWayAudio ? "yes" : "no";
      createBody.checkInUse = createBody.checkInUse ? "on" : "";
      createBody.meId = createBody.meId == "" ? 0 : createBody.meId;
      createBody.tenantId = this.selectedTenant.id;

      this.$emit("createOperation", createBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    getRandomKey() {
      const randomString = () =>
        Math.random()
          .toString(36)
          .slice(2);
      return `${randomString()}-${randomString()}$${randomString()}`;
    },

    clearFields() {
      this.number = "";
      this.newMediafile = null;
      this.createForm = {
        tenantId: null,
        number: "",
        name: "",
        twoWayAudio: false,
        checkInUse: false,
        extensions: [],
        meId: 0
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.el-checkbox {
  margin-left: 0;
}
</style>
